import { Component, OnInit, ViewChild, AfterViewInit, ElementRef } from '@angular/core';
import {DataSource, CollectionViewer} from '@angular/cdk/collections';
import { AuditService } from '../../services/audit.service';
import { Observable ,  BehaviorSubject , of,  fromEvent } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import {catchError, finalize, tap, distinctUntilChanged, debounceTime} from 'rxjs/operators';
import { CommonfilterService } from '../../services/commonfilter.service';
import { AccountService } from 'src/app/services/account.service';
import { projectConstants } from 'src/app/shared/constants/project-constants';

@Component({
  selector: 'app-audits',
  templateUrl: './audits.component.html',
  styleUrls: ['./audits.component.css']
})
export class AuditsComponent implements AfterViewInit , OnInit {


  collapsed;
  auditCount: number;

  tableFilters = '';

  dataSource = new AuditDataSource(this.auditService);

  displayedColumns = [ 'date', 'time', 'Action', 'Category', 'SubCategory', 'subject', 'text', 'accountId', 'userName',
  'corporateId',  'userIpAddress'];

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  @ViewChild('go', {static: false}) button: ElementRef;

  currentDate: string;
  config: any = {};
  Actions: any;
  userTypes: any;
  corporates: any = [];
  corporateModel = 0;
  categories: any = [];
  subCategories: any = [];
  categoryModel = 0;
  screenHeight;
  screenWidth;
  small_device_display = false;
  constructor(private auditService: AuditService, private commomFilterService: CommonfilterService,
     private accountService: AccountService ) {
    this.getConfigDetails();
    // this.accountService.getCorporates()
    // .subscribe(data => {
    //   this.corporates = data;
    //   console.log(this.corporates);
    // });
    this.onResize();
   }

  ngOnInit() {

    this.getTotalCount();
    this.dataSource.loadAudits( '', 'false', 0, 100);
    this.currentDate = new Date().toISOString().split('T')[0];
  }

  ngAfterViewInit() {

    this.paginator.page
    .pipe(
        tap(() => this.loadAuditsPage())
    )
    .subscribe();


    fromEvent(this.button.nativeElement, 'click')
    .pipe(
        debounceTime(150),
        distinctUntilChanged(),
        tap(() => {
            this.tableFilters = this.commomFilterService.createfilterParams('audit');
            this.getTotalCountByFilters(this.tableFilters);
            this.paginator.pageIndex = 0;
            this.loadAuditsPage();

        })
    )
    .subscribe();

}
onResize() {
  this.screenHeight = window.innerHeight;
  this.screenWidth = window.innerWidth;
  console.log(this.screenWidth);
  if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
    console.log(projectConstants.SMALL_DEVICE_BOUNDARY);
    console.log(this.screenWidth);
    this.small_device_display = true;
  } else {
    this.small_device_display = false;
  }
}
loadAuditsPage() {
  const counte = (this.paginator.pageSize * (this.paginator.pageIndex + 1)) - 100;

  this.dataSource.loadAudits(

    this.tableFilters,
    'false',
    counte,
    this.paginator.pageSize);
}
getTotalCount() {
  this.auditService.getCount()
  .subscribe( res => this.auditCount = res);
}

getTotalCountByFilters(filter) {
 this.auditService.getTotalFilterCount(filter)
 .subscribe( data => this.auditCount = data);
}
getConfigDetails() {
 this.commomFilterService.getConfigData()
 .subscribe(res => {
   this.config = res;
   console.log(this.config.actionType);
   console.log(this.config.userType);
   console.log(this.config.auditCategorySubCategoryDetails);
  this.Actions = this.config.actionType;
  this.userTypes = this.config.userType;
  this.categories = this.config.auditCategorySubCategoryDetails;
 }
 );


}
onCategoryChange(event) {
  this.subCategories = [];
  for (let i = 0; i < this.categories.length; i++) {
    // tslint:disable-next-line:triple-equals
    if (event.target.value === this.categories[i].category) {
      console.log('inside');
        this.subCategories = this.categories[i].subCategories;
        break;
  }
}

}
}

export class AuditDataSource implements DataSource<any> {

  private auditSubject = new BehaviorSubject<any>([]);

  private loadingSubject = new BehaviorSubject<boolean>(false);

  public loading$ = this.loadingSubject.asObservable();

  constructor(private auditService: AuditService) {

  }
  connect(collectionViewer: CollectionViewer): Observable<any> {
     return this.auditSubject.asObservable();

  }
  disconnect(collectionViewer: CollectionViewer): void {
    this.auditSubject.complete();
    this.loadingSubject.complete();
  }

  loadAudits( filter,
  sortDirection, tcount, pageSize) {

  this.loadingSubject.next(true);

  this.auditService.getAudits( filter, sortDirection,
    tcount, pageSize).pipe(
     catchError(() => of([])),
      finalize(() => this.loadingSubject.next(false))
    )
    .subscribe(
      audits => {this.auditSubject.next(audits);
      }
    );
  }
}
